import { Grid, Paper } from "@mui/material";
import React from "react";
import { Dialog } from "../../Dialog";
import styled from "@mui/material/styles/styled";
const ContributionModalStyle = styled(Paper)(({ theme }) => ({
    ".header": {
        borderBottom: "1px solid rgb(140, 130, 122)",
        ".MuiGrid-root": {
            padding: "20px 5px",
        },
    },
    ".middle-data": {
        ".MuiGrid-root": {
            padding: "5px 5px",
        },
        padding: "5px 0",
    },
    ".total-contribution": {
        ".MuiGrid-root": {
            padding: "10px  5px",
        },
        backgroundColor: "rgb(246, 246, 246)",
        padding: "5px 0",
    },
}));
const ContributionModal = (props) => {
    return (React.createElement(Dialog, { show: true, title: "Your Community Sharing", body: () => props.data.length ? React.createElement(SuccessContributors, Object.assign({}, props)) : (React.createElement("p", null, "No contribution data available. Please try again later.")), CloseIcon: true, buttons: [
            {
                label: "Close",
                size: "large",
                variant: "text",
                type: "button",
                className: "Close",
                onClick: () => props.SetViewDownloadModal(""),
            },
        ], handleCallback: (data) => {
            props.SetViewDownloadModal("");
        } }));
};
export default React.memo(ContributionModal);
const SuccessContributors = (props) => {
    return (React.createElement(ContributionModalStyle, null,
        React.createElement(Grid, { container: true },
            React.createElement(Grid, { container: true, className: "header" },
                React.createElement(Grid, { xs: 6 }, "Member"),
                React.createElement(Grid, { xs: 6 }, "Contribution Amount")),
            React.createElement(Grid, { container: true, className: "middle-data" }, props.data.map((details) => (React.createElement(Grid, { container: true, className: "mb-2" },
                React.createElement(Grid, { xs: 6 }, details.name),
                React.createElement(Grid, { xs: 6 }, details.amount))))),
            React.createElement(Grid, { container: true, className: "total-contribution" },
                React.createElement(Grid, { xs: 6 }, "Total Contribution"),
                React.createElement(Grid, { xs: 6 }, props.totalContributorn)))));
};
